/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import GistEditor, { GistEditorArgs, SupportedFlyMethods } from 'cio/components/in-app-messages-page/gist-editor';
import { action } from '@ember/object';
import { isEmpty } from '@ember/utils';

const getElementAbsoluteHeight = (element: any) => {
  if (element == null) {
    return 0;
  }
  // Get the DOM Node if you pass in a string
  element = typeof element === 'string' ? document.querySelector(element) : element;
  let styles = getComputedStyle(element);
  let margin = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  return Math.ceil(element.offsetHeight + margin);
};

export const iFrameMaxHeight = (fullscreenMode = false) => {
  let mainContainer = document.getElementsByClassName('js-main-app-container');
  let mainContainerHeight = getElementAbsoluteHeight(mainContainer[0]);

  let breadcrumbs = document.getElementsByClassName('js-page-header-wrapper');
  let breadcrumbsHeight = getElementAbsoluteHeight(breadcrumbs[0]);

  if (fullscreenMode) {
    return mainContainerHeight > 0
      ? // 16 * 3 are padding and margin values not part of the elements used to calculate the available height
        `${mainContainerHeight - ((breadcrumbsHeight ?? 0) + 16 * 3)}px`
      : // 86vh works well as the full screen mode default value when the banner at top is present
        // eslint-disable-next-line spellcheck/spell-checker
        IFRAME_FULLSCREEN_DEFAULT_HEIGHT;
  }
  let inAppHeader = document.getElementsByClassName('js-in-app-messages-page-header');
  let inAppHeaderHeight = getElementAbsoluteHeight(inAppHeader[0]);
  let footer = document.getElementsByTagName('footer');
  let footerHeight = getElementAbsoluteHeight(footer[0]);

  return mainContainerHeight > 0 && inAppHeaderHeight > 0
    ? // 16 * 3 are padding and margin values not part of the elements used to calculate
      `${mainContainerHeight - inAppHeaderHeight - ((breadcrumbsHeight ?? 0) + (footerHeight ?? 0) + 16 * 4)}px`
    : // 64vh works well as the default value when the banner at top is present
      // eslint-disable-next-line spellcheck/spell-checker
      IFRAME_DEFAULT_HEIGHT;
};

interface MessageTemplateEditorArgs extends GistEditorArgs {
  messageId?: string;
}

// eslint-disable-next-line spellcheck/spell-checker
export const IFRAME_FULLSCREEN_DEFAULT_HEIGHT = '86vh';
// eslint-disable-next-line spellcheck/spell-checker
export const IFRAME_DEFAULT_HEIGHT = '64vh';

export default class MessageTemplateEditor extends GistEditor<MessageTemplateEditorArgs> {
  get editorPath() {
    let { messageId } = this.args;
    let path = '/embed/';
    if (messageId != null && messageId.length > 0) {
      path += `message/${messageId}`;
    }
    return path;
  }

  get iframeStyle() {
    // Get browser height and substract banners, headers, breadcrumbs
    // and the footer to get the maximum height available for the iframe
    let { messageId } = this.args;
    let style = `height: ${iFrameMaxHeight(!isEmpty(messageId))};`;
    if (!this.isUserLoggedIn) {
      style += 'display: none !important;';
    }
    return style;
  }

  @action
  confirmDeleteMessage() {
    this.postMessageToGist({
      fly: {
        method: SupportedFlyMethods.DeleteMessageConfirmed,
        payload: {
          messageId: this.args.messageId,
        },
      },
    });
    this.isShowingDeleteMessageModal = false;
  }

  @action
  cancelDeleteMessage() {
    this.postMessageToGist({
      fly: {
        method: SupportedFlyMethods.DeleteMessageCancelled,
        payload: {
          messageId: this.args.messageId,
        },
      },
    });
    this.isShowingDeleteMessageModal = false;
  }

  @action
  onSelectAsset(assetPath: string) {
    this.postMessageToGist({
      fly: {
        method: SupportedFlyMethods.OnSelectAsset,
        payload: {
          assetPath,
          assetInputId: this.assetInputId,
        },
      },
    });
    this.isShowingAssetLibraryModal = false;
  }
}
